<template>
<div class="left-sidebar">
    <template v-for="productGroup in products.productGroups">
      <product-group-navigation :productGroup="productGroup" v-bind:key="productGroup.productGroupId" ></product-group-navigation>
    </template>
</div>
</template>

<script>
import ProductGroupNavigation from './ProductGroupNavigation';

export default {
  name: 'product-navigation',
  created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },
  computed: {
    products() {
      return this.$store.getters.allProducts;
    },
  },
  components: {
    'product-group-navigation': ProductGroupNavigation,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/ProductNavigation.vue